import ActivityCardBody from './activityItem.view';

export default ActivityCardBody;
